// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: slack_notification.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "com.anko.darwin";

export interface SlackUser {
  /** Unique identifier for the Slack user. */
  id?:
    | string
    | undefined;
  /** Name of the Slack user. */
  name?:
    | string
    | undefined;
  /** Real name of the Slack user. */
  real_name?:
    | string
    | undefined;
  /** Display name of the Slack user. */
  display_name?:
    | string
    | undefined;
  /** Indicates if the user is a bot. */
  is_bot?: boolean | undefined;
}

export interface SlackChannel {
  /** Unique identifier for the Slack channel. */
  id?:
    | string
    | undefined;
  /** Name of the Slack channel. */
  name?:
    | string
    | undefined;
  /** Indicates if the channel is private. */
  is_private?:
    | boolean
    | undefined;
  /** Number of members in the channel. */
  num_members?: number | undefined;
}

export interface SlackNotificationConfig {
  /** Slack channel where notification should be sent. */
  channel?:
    | SlackChannel
    | undefined;
  /** Slack users to be tagged in the notification, if any. */
  tag_users: SlackUser[];
  /** Title of the notification, if any. */
  message_title?:
    | string
    | undefined;
  /** Hyperlink on the title, if any. */
  title_hyperlink?: string | undefined;
}

/** Request for sending slack notification. */
export interface SlackNotificationRequest {
  /** Configuration for the slack notification. */
  notification_config?:
    | SlackNotificationConfig
    | undefined;
  /** Content of the slack message. */
  message_content?:
    | string
    | undefined;
  /** Linked chat session id that has to be linked with this slack notification. */
  linked_chat_session_id?: string | undefined;
}

function createBaseSlackUser(): SlackUser {
  return { id: undefined, name: undefined, real_name: undefined, display_name: undefined, is_bot: undefined };
}

export const SlackUser: MessageFns<SlackUser> = {
  encode(message: SlackUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.real_name !== undefined) {
      writer.uint32(26).string(message.real_name);
    }
    if (message.display_name !== undefined) {
      writer.uint32(34).string(message.display_name);
    }
    if (message.is_bot !== undefined) {
      writer.uint32(40).bool(message.is_bot);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlackUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.real_name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.is_bot = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlackUser {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      real_name: isSet(object.real_name) ? globalThis.String(object.real_name) : undefined,
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : undefined,
      is_bot: isSet(object.is_bot) ? globalThis.Boolean(object.is_bot) : undefined,
    };
  },

  toJSON(message: SlackUser): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.real_name !== undefined) {
      obj.real_name = message.real_name;
    }
    if (message.display_name !== undefined) {
      obj.display_name = message.display_name;
    }
    if (message.is_bot !== undefined) {
      obj.is_bot = message.is_bot;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SlackUser>, I>>(base?: I): SlackUser {
    return SlackUser.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SlackUser>, I>>(object: I): SlackUser {
    const message = createBaseSlackUser();
    message.id = object.id ?? undefined;
    message.name = object.name ?? undefined;
    message.real_name = object.real_name ?? undefined;
    message.display_name = object.display_name ?? undefined;
    message.is_bot = object.is_bot ?? undefined;
    return message;
  },
};

function createBaseSlackChannel(): SlackChannel {
  return { id: undefined, name: undefined, is_private: undefined, num_members: undefined };
}

export const SlackChannel: MessageFns<SlackChannel> = {
  encode(message: SlackChannel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.is_private !== undefined) {
      writer.uint32(24).bool(message.is_private);
    }
    if (message.num_members !== undefined) {
      writer.uint32(32).int32(message.num_members);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackChannel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlackChannel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.is_private = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.num_members = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlackChannel {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      is_private: isSet(object.is_private) ? globalThis.Boolean(object.is_private) : undefined,
      num_members: isSet(object.num_members) ? globalThis.Number(object.num_members) : undefined,
    };
  },

  toJSON(message: SlackChannel): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.is_private !== undefined) {
      obj.is_private = message.is_private;
    }
    if (message.num_members !== undefined) {
      obj.num_members = Math.round(message.num_members);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SlackChannel>, I>>(base?: I): SlackChannel {
    return SlackChannel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SlackChannel>, I>>(object: I): SlackChannel {
    const message = createBaseSlackChannel();
    message.id = object.id ?? undefined;
    message.name = object.name ?? undefined;
    message.is_private = object.is_private ?? undefined;
    message.num_members = object.num_members ?? undefined;
    return message;
  },
};

function createBaseSlackNotificationConfig(): SlackNotificationConfig {
  return { channel: undefined, tag_users: [], message_title: undefined, title_hyperlink: undefined };
}

export const SlackNotificationConfig: MessageFns<SlackNotificationConfig> = {
  encode(message: SlackNotificationConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channel !== undefined) {
      SlackChannel.encode(message.channel, writer.uint32(10).fork()).join();
    }
    for (const v of message.tag_users) {
      SlackUser.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.message_title !== undefined) {
      writer.uint32(26).string(message.message_title);
    }
    if (message.title_hyperlink !== undefined) {
      writer.uint32(34).string(message.title_hyperlink);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackNotificationConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlackNotificationConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.channel = SlackChannel.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tag_users.push(SlackUser.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message_title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.title_hyperlink = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlackNotificationConfig {
    return {
      channel: isSet(object.channel) ? SlackChannel.fromJSON(object.channel) : undefined,
      tag_users: globalThis.Array.isArray(object?.tag_users)
        ? object.tag_users.map((e: any) => SlackUser.fromJSON(e))
        : [],
      message_title: isSet(object.message_title) ? globalThis.String(object.message_title) : undefined,
      title_hyperlink: isSet(object.title_hyperlink) ? globalThis.String(object.title_hyperlink) : undefined,
    };
  },

  toJSON(message: SlackNotificationConfig): unknown {
    const obj: any = {};
    if (message.channel !== undefined) {
      obj.channel = SlackChannel.toJSON(message.channel);
    }
    if (message.tag_users?.length) {
      obj.tag_users = message.tag_users.map((e) => SlackUser.toJSON(e));
    }
    if (message.message_title !== undefined) {
      obj.message_title = message.message_title;
    }
    if (message.title_hyperlink !== undefined) {
      obj.title_hyperlink = message.title_hyperlink;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SlackNotificationConfig>, I>>(base?: I): SlackNotificationConfig {
    return SlackNotificationConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SlackNotificationConfig>, I>>(object: I): SlackNotificationConfig {
    const message = createBaseSlackNotificationConfig();
    message.channel = (object.channel !== undefined && object.channel !== null)
      ? SlackChannel.fromPartial(object.channel)
      : undefined;
    message.tag_users = object.tag_users?.map((e) => SlackUser.fromPartial(e)) || [];
    message.message_title = object.message_title ?? undefined;
    message.title_hyperlink = object.title_hyperlink ?? undefined;
    return message;
  },
};

function createBaseSlackNotificationRequest(): SlackNotificationRequest {
  return { notification_config: undefined, message_content: undefined, linked_chat_session_id: undefined };
}

export const SlackNotificationRequest: MessageFns<SlackNotificationRequest> = {
  encode(message: SlackNotificationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.notification_config !== undefined) {
      SlackNotificationConfig.encode(message.notification_config, writer.uint32(10).fork()).join();
    }
    if (message.message_content !== undefined) {
      writer.uint32(18).string(message.message_content);
    }
    if (message.linked_chat_session_id !== undefined) {
      writer.uint32(26).string(message.linked_chat_session_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackNotificationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlackNotificationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.notification_config = SlackNotificationConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message_content = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.linked_chat_session_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlackNotificationRequest {
    return {
      notification_config: isSet(object.notification_config)
        ? SlackNotificationConfig.fromJSON(object.notification_config)
        : undefined,
      message_content: isSet(object.message_content) ? globalThis.String(object.message_content) : undefined,
      linked_chat_session_id: isSet(object.linked_chat_session_id)
        ? globalThis.String(object.linked_chat_session_id)
        : undefined,
    };
  },

  toJSON(message: SlackNotificationRequest): unknown {
    const obj: any = {};
    if (message.notification_config !== undefined) {
      obj.notification_config = SlackNotificationConfig.toJSON(message.notification_config);
    }
    if (message.message_content !== undefined) {
      obj.message_content = message.message_content;
    }
    if (message.linked_chat_session_id !== undefined) {
      obj.linked_chat_session_id = message.linked_chat_session_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SlackNotificationRequest>, I>>(base?: I): SlackNotificationRequest {
    return SlackNotificationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SlackNotificationRequest>, I>>(object: I): SlackNotificationRequest {
    const message = createBaseSlackNotificationRequest();
    message.notification_config = (object.notification_config !== undefined && object.notification_config !== null)
      ? SlackNotificationConfig.fromPartial(object.notification_config)
      : undefined;
    message.message_content = object.message_content ?? undefined;
    message.linked_chat_session_id = object.linked_chat_session_id ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
